import esimApi from "../api/EsimApiClient";

const API_BASE_URL = "https://esim.globtel.biz/api";

export const fetchCarrierEsims = async ({
  skip = 0,
  limit = 50,
  sort_by = "created_at",
  sort_order = "desc",
  filters = {},
}) => {
  const params = {
    skip,
    limit,
    sort_by,
    sort_order,
    ...Object.fromEntries(
      Object.entries(filters).filter(
        ([k, v]) => v !== undefined && v !== null && v !== "",
      ),
    ),
  };

  const { data } = await esimApi.esimPrivateApiClient.get(
    "/esim/batch/carrier",
    { params },
  );
  return data; // { total, filtered, items }
};

export async function fetchEsimBatchAdmin({
  token,
  skip = 0,
  limit = 50,
  sort_by = "created_at",
  sort_order = "desc",
  filters = {},
}) {
  const params = new URLSearchParams({
    skip,
    limit,
    sort_by,
    sort_order,
    ...Object.fromEntries(
      Object.entries(filters).filter(
        ([k, v]) => v !== undefined && v !== null && v !== "",
      ),
    ),
  });

  const response = await fetch(
    `${API_BASE_URL}/esim/batch/admin?${params.toString()}`,
    {
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Error fetching eSIM data: ${response.statusText}`);
  }

  return response.json();
}
